module.exports = __webpack_public_path__ + "static/logo_kitatraumfaenger-8d550135c33fe21b5bd01670a811a267.svg";